import { PhysicalAddress } from './PhysicalAddress'

/**
 * Contact information.
 */
export interface ContactInfo {
  readonly email: string
  readonly phoneNumber: string
  readonly physicalAddress: PhysicalAddress
}

export const ContactInfo = {
  /**
   * Empty contact info.
   */
  empty: {
    email: '',
    phoneNumber: '',
    physicalAddress: PhysicalAddress.empty,
  } satisfies ContactInfo,
}
